export default __webpack_public_path__ + "static/media/p7.f661a120.jpg";